module.exports = {
          srcSet: __webpack_public_path__ + "images/1912-f6b76a830639852f2c01a160113123c3-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1912-9659f24834bd88f26435f6cbc35709db-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1912-f6b76a830639852f2c01a160113123c3-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1912-9659f24834bd88f26435f6cbc35709db-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1912-f6b76a830639852f2c01a160113123c3-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1912-f6b76a830639852f2c01a160113123c3-320.jpg"},
          
          width: 320,
          height: 251
        }